import { isNonNullable, isNullable } from "../../type-guards";
export class StringUtils {
    static kanaToHira(kana) {
        return kana.replace(/[\u30a1-\u30f6]/g, (match) => {
            const chr = match.charCodeAt(0) - 0x60;
            return String.fromCharCode(chr);
        });
    }
    static hiraToKana(hira) {
        return hira.replace(/[\u3041-\u3096]/g, (match) => {
            const chr = match.charCodeAt(0) + 0x60;
            return String.fromCharCode(chr);
        });
    }
    static fullwidthToHalf(input) {
        return input.replace(/[Ａ-Ｚａ-ｚ０-９！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［＼］＾＿｀｛｜｝～]/g, (v) => String.fromCharCode(v.charCodeAt(0) - 0xfee0));
    }
    /**
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
     */
    static escapeRegExp(input) {
        return input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    static toSafeFilename(input, replaceTo) {
        return input.replace(/[<>:/?*|"|[\]\\]/g, replaceTo);
    }
    static isEmpty(v) {
        return isNullable(v) || StringUtils.isEmptyString(v);
    }
    static isEmptyString(v) {
        return isNullable(v) || v.trim() === "";
    }
    static isNumberString(v) {
        return !isNaN(parseFloat(v)) && isFinite(Number(v));
    }
    static blankToUndefinedObject(obj) {
        if (Object.keys(obj).length === 0) {
            return undefined;
        }
        Object.keys(obj).forEach((key) => {
            // stringの場合、空文字の場合はundefinedに変換
            if (isNonNullable(obj[key]) &&
                typeof obj[key] === "string" &&
                StringUtils.isEmpty(obj[key])) {
                obj = { ...obj, [key]: undefined };
            }
        });
        return obj;
    }
    static blankToUndefined(v) {
        if (this.isEmpty(v)) {
            return undefined;
        }
        return v;
    }
    static padding(word, length, paddingText = "0") {
        return (paddingText.repeat(length) + word).slice(-length);
    }
    // 上のpaddingだともし仮に３文字の数字を入れた場合、３文字目が消えてしまうため追加
    // TODO: over:trueなどを作って上とまとめる
    static paddingOver(word, length, paddingText = "0") {
        if (word.length > length)
            return word;
        return (paddingText.repeat(length) + word).slice(-length);
    }
    static capitalizeHead(input) {
        return input.charAt(0).toUpperCase() + input.slice(1);
    }
    static uncapitalizeHead(input) {
        return input.charAt(0).toLowerCase() + input.slice(1);
    }
    static similar(input, targets) {
        if (StringUtils.isEmptyString(input ?? "")) {
            return undefined;
        }
        const matcher = new RegExp(StringUtils.escapeRegExp(StringUtils.fullwidthToHalf(input)));
        return targets
            .filter((target) => {
            return matcher.test(StringUtils.fullwidthToHalf(target));
        })
            .at(0);
    }
    static matcher(query) {
        return new RegExp(StringUtils.escapeRegExp(StringUtils.kanaToHira(query ?? "")), "i");
    }
    static matcherTarget(v) {
        return StringUtils.kanaToHira(v);
    }
    static isMatchCandidates(query, candidates) {
        if (StringUtils.isEmpty(query)) {
            return true;
        }
        const searchText = StringUtils.escapeRegExp(StringUtils.fullwidthToHalf(query));
        const matcher = new RegExp(searchText, "i");
        const matchers = /[a-z]{1}$/.test(searchText)
            ? [matcher, new RegExp(searchText.slice(0, -1), "i")]
            : [matcher];
        return matchers.some((matcher) => candidates.some((candidate) => matcher.test(StringUtils.fullwidthToHalf(candidate))));
    }
    static findDuplicates(arr) {
        const countsAndIndices = arr.reduce((acc, item, index) => {
            if (isNonNullable(acc[item])) {
                acc[item].count++;
                acc[item].indices.push(index);
            }
            else {
                acc[item] = { count: 1, indices: [index] };
            }
            return acc;
        }, {});
        return Object.entries(countsAndIndices)
            .filter(([_, data]) => data.count > 1)
            .map(([item, data]) => ({ value: item, indices: data.indices }));
    }
}
//# sourceMappingURL=string-utils.js.map